/*import {
    FormDialogFactory,FormStateFactory,UtilsFactory
} from './';*/

export class MainCoreFactory {/*
    constructor(public FormDialogFactory: FormDialogFactory, public FormStateFactory: FormStateFactory, public UtilsFactory: UtilsFactory) {

    }*/
}